import Cookies from 'js-cookie'
import { Modal } from "bootstrap";

const initial = () => {
    const domains = getDomainsThatAreNotYetBeenShown(document.querySelectorAll('.domain-expires'));

    if (!domains.length) {
        return;
    }

    showModal(domains[0]);

    domains.forEach(($domain, key) => {
        let $nextDomain = domains[key + 1];

        if ($nextDomain) {
            switchModals($domain, $nextDomain);
        }

        document.addEventListener('click', function (event) {
            if (!event.target.matches('.continue-payment')) return;
            const expriesModal = Modal.getOrCreateInstance(event.target.closest('.modal'));
            expriesModal.hide();
        }, false);
    });
}

const getDomainsThatAreNotYetBeenShown = (nodeList) => {
    let domainKey = 0;

    let domains = [];
    nodeList.forEach((domainElement) => {
        let $domainElement = $(domainElement);

        if (!isDomainShown($domainElement.data('domain'))) {
            domains[domainKey] = $domainElement;

            domainKey += 1;
        }
    });

    return domains;
}

const isDomainShown = (domainName) => {
    return Cookies.get('shownReminder-' + domainName)
}

const setDomainShown = (domainName) => {
    Cookies.set('shownReminder-' + domainName, true, { expires: euAdminConfig.purchaseFormReminderExpires / 86400 });
}

const switchModals = ($fromDomain, $toDomain) => {
    $fromDomain.on('hidden.bs.modal', (e) => {
        showModal($toDomain);
    });

    hideModal($fromDomain);
}

const showModal = ($domain) => {
    const modal = Modal.getOrCreateInstance($domain);
    modal.show();

    setDomainShown($domain.data('domain'));
}

const hideModal = ($domain) => {
    const modal = Modal.getOrCreateInstance($domain);
    modal.hide();
}

export default initial;
